import { render, staticRenderFns } from "./ProductionIntroduction.vue?vue&type=template&id=5dabe421&scoped=true&"
import script from "./ProductionIntroduction.vue?vue&type=script&lang=js&"
export * from "./ProductionIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./ProductionIntroduction.vue?vue&type=style&index=0&id=5dabe421&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dabe421",
  null
  
)

export default component.exports